export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/f5c29e86d3a5b6f06334d35443df7aba.svg";